import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch.js";
import debounce from "lodash.debounce";
import { listCallToAttentionService } from "../services/listCallToAttention.service.js";

export const useCallToAttentionQuery = (filters) => {
  const fetchData = useFetch();
  const [callToAttention, setCallToAttention] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchCallToAttention = async () => {
      try {
        setLoading(true);
        const response = await listCallToAttentionService(fetchData)({
          filters: { page: currentPage, limit: 25, ...filters },
        });
        setCallToAttention(response.data);
        setTotalPages(response.totalPages);
        setTotal(response.total);
      } catch (error) {
        throw error;
      } finally {
        setLoading(false);
      }
    };

    const debounced = debounce(fetchCallToAttention, 500);
    debounced();
    return () => {
      debounced.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, filters, refresh]);

  return {
    callToAttention,
    loading,
    currentPage,
    onChangePage: (page) => setCurrentPage(page),
    totalPages,
    total,
    refresh: () => setRefresh((prev) => !prev),
  };
};
